import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, layout, color, border, typography, variant } from 'styled-system';

import buttonBaseStyles from './ButtonStyle';

const variants = variant({
  variants: {
    small: {
      p: '2px 10px',
      fontSize: 1,
      borderRadius: '20px',
      height: '28px',
    },
    medium: {
      p: '12px 24px',
      fontSize: 1,
      borderRadius: '20px',
      height: '48px',
    },
    default: {
      fontSize: 2,
    },
  },
});

const ButtonBase = styled.button.attrs(({ disabled, onClick }) => ({
  onClick: disabled ? undefined : onClick,
}))`
  ${buttonBaseStyles}
  ${space}
  ${layout}
  ${color}
  ${border}
  ${typography}
  ${variants}
`;

ButtonBase.propTypes = {
  as: PropTypes.oneOfType([
    PropTypes.oneOf(['button', 'a', 'summary', 'input']),
    PropTypes.elementType,
  ]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

ButtonBase.defaultProps = {
  minWidth: 100,
  variant: 'default',
};

export default ButtonBase;
